import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { PaymentPolicyResponse } from '../../Models/ebayPolicyModels/getPaymentPoliciesResponse';
import { ReturnPolicyResponse } from '../../Models/ebayPolicyModels/getReturnPoliciesResponse';
import { FulfillmentPolicyResponse } from '../../Models/ebayPolicyModels/getFulfillmentPoliciesResponse';
import {
  MarketplaceAttributeRequest,
  MarketplaceAttributeResponse,
} from '../../Models/MarketplaceCategoryModel';
import { EbayInventoryLocation } from '../../Models/EbayInventoryLocationModel';

@Injectable({
  providedIn: 'root',
})
export class EbayAPIService {
  baseUrl: string = environment.listerApiBaseUrl;
  constructor(private http: HttpClient) {}

  getReturnPolicies(authToken: string) {
    const url = `${this.baseUrl}/EbayAPIs/Return?isSandbox=false`;
    const headers = new HttpHeaders({ accessToken: `${authToken}` });

    return this.http.get<ReturnPolicyResponse>(url, { headers });
  }
  getPaymentPolicies(authToken: string) {
    const url = `${this.baseUrl}/EbayAPIs/Payment?isSandbox=false`;
    const headers = new HttpHeaders({ accessToken: `${authToken}` });

    return this.http.get<PaymentPolicyResponse>(url, { headers });
  }
  getFulfillmentPolicies(authToken: string) {
    const url = `${this.baseUrl}/EbayAPIs/Fulfill?isSandbox=false`;
    const headers = new HttpHeaders({ accessToken: `${authToken}` });

    return this.http.get<FulfillmentPolicyResponse>(url, { headers });
  }
  getEbayCategoryAttributes(Category: MarketplaceAttributeRequest) {
    const url = `${this.baseUrl}/EbayAPIs/Attribute?categoryId=${Category.marketplaceCategoryId}`;
    const headers = new HttpHeaders({
      accessToken: `${Category.marketpalceAccessToken}`,
    });

    return this.http.get<MarketplaceAttributeResponse[]>(url, { headers });
  }
  withdrawEbayOffer(authToken: string, listingId: number) {
    const url = `${this.baseUrl}/EbayAPIs/Withdraw?productMarketplaceListingId=${listingId}`;
    const headers = new HttpHeaders({ accessToken: `${authToken}` });

    return this.http.post<boolean>(url, { headers });
  }
  createWarehouseLocation(authToken: string) {
    const inventoryLocation = new EbayInventoryLocation();
    const url = `${this.baseUrl}/EbayAPIs/Inventory`;
    const headers = new HttpHeaders({ accessToken: `${authToken}` });

    return this.http.post(url, inventoryLocation, { headers });
  }
  updateWarehouseLocation(authToken: string) {
    const inventoryLocation = new EbayInventoryLocation();
    const url = `${this.baseUrl}/EbayAPIs/Inventory`;
    const headers = new HttpHeaders({ accessToken: `${authToken}` });

    return this.http.put(url, inventoryLocation, { headers });
  }
  getWarehouseLocation(authToken: string) {
    const url = `${this.baseUrl}/EbayAPIs/Inventory/Lister-Warehouse`;
    const headers = new HttpHeaders({ accessToken: `${authToken}` });
    return this.http.get(url, { headers });
  }
  getWarehouseLocations(authToken: string) {
    const url = `${this.baseUrl}/EbayAPIs/Inventory`;
    const headers = new HttpHeaders({ accessToken: `${authToken}` });
    return this.http.get(url, { headers });
  }
  deleteWarehouseLocation(authToken: string) {
    const url = `${this.baseUrl}/EbayAPIs/Inventory/Lister-Warehouse`;
    const headers = new HttpHeaders({ accessToken: `${authToken}` });
    return this.http.delete(url, { headers });
  }
}
